import React, { Component } from "react";
import { connect } from 'react-redux';
import { getPopupConfig } from '../../components/Popup';
import { DeviceType } from '../../enums';
import constants from '../../globalization';
import API from '../../requests';
import View from './views';
import EventEmitter from '../../util/event-emitter';
import FireboardUtils from '../../util/fireboard-util';
// import sampleJson from './components/sample.json';
import UTILLib from "../../util";
import { saLoginAction } from '../../store/actions/sa-login';
import { version } from '../../../package.json';
import {
  getStoreJobs as getStoreJobsList,
} from '../../store/actions/login';
import withSocketContext from '../../context-api/SocketContext/withSocketContext';
import { updateComponentState } from '../../store/actions/component-state';

export interface Props {
  dispatchLogin: Function;
  reduxProps: StateType;
}

export interface State {
  popup: PopupContentType | typeof undefined;
  isCardLogin: boolean,
  password: string,
}

const KEYPAD_MAX_LENGTH = 10;

class ServerAppLogin extends Component<Props, State> {
  state = {
    popup: undefined,
    isCardLogin: false,
    password: '',
  };

  componentWillMount = () => {
    const {
      history,
      reduxProps: { storeInfo, deviceInfo },
    } = this.props;

    if (!storeInfo.data || !deviceInfo.deviceExternalId) {
      history.push({
        pathname: '/',
        state: { deviceTypeId: 8 }
      });
      return;
    }

    if (storeInfo.data?.serverAppFeatures?.supportsLoginUsingCard) {
      this.state.isCardLogin = true;
    }
  }

  componentDidMount = () => {
    API.setURL(process.env.REACT_APP_IAPI_BASE_URL);
    const { dispatchUpdateCompState } = this.props;
    dispatchUpdateCompState && dispatchUpdateCompState({ mounted: true });
  }

  componentWillUnmount() {
    const { dispatchUpdateCompState } = this.props;
    dispatchUpdateCompState && dispatchUpdateCompState({ mounted: false });
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    const { reduxProps, location } = newProps;
    const { reduxProps: prevReduxProps } = this.props;
    const { serverAppLogin, deviceInfo, storeInfo, getStoreJobs } = reduxProps;
    if (serverAppLogin.timestamp !== prevReduxProps.serverAppLogin.timestamp) {
      if (serverAppLogin.isFetching) {
        const popup = getPopupConfig('spinner');
        popup.heading = constants.loginLoadingHeading;
        this.setState({ popup });
      } else if (serverAppLogin.data) {
        API.setIdsInHeaders(storeInfo.data.id, deviceInfo.deviceExternalId, serverAppLogin.data.id);
        // if (serverAppLogin.data && serverAppLogin.data.clockInRequired) {
        //   this.fetchJobsList(login.data.id);
        //   return;
        // }
        this.getStoreJobs();
        // this.onLoginSuccess(reduxProps);
        const { history } = this.props;
        history.push("/teamShare");
      } else if (serverAppLogin.error) {
        this.onLoginError(serverAppLogin.error);
      }
    }

    if (getStoreJobs.timestamp !== prevReduxProps.getStoreJobs.timestamp) {
      if (getStoreJobs.data) {
        this.setState({ popup: undefined });
      } else if (getStoreJobs.error) {
        this.onLoginError(getStoreJobs.error);
      } else {
        const popup = getPopupConfig('spinner');
        popup.heading = constants.fetchingJobs;
        this.setState({ popup });
      }
    }
  }

  getStoreJobs = () => {
    const {
      dispatchGetStoreJobs,
      reduxProps: { storeInfo },
    } = this.props;
    dispatchGetStoreJobs({ storeId: storeInfo.data && storeInfo.data.id });
  };

  onLoginError = error => {
    let popup = null;
    if (error.errorCode === constants.clockInRequiredCode) {
      popup = getPopupConfig('error');
      popup.heading = constants.jobListClockIn;
      popup.message = constants.clockInRequired;
      popup.buttons = [
        {
          text: constants.no,
          onPress: this.closePopup,
        },
        {
          text: constants.yes,
          onPress: this.closePopup,
        },
      ];
    } else {
      popup = getPopupConfig('error', this.closePopup);
      popup.message = error;
    }
    this.setState({ popup });
  };

  closePopup = () => {
    this.setState({ popup: undefined });
  };

  onPressReset = () => {
    this.setState({ popup: undefined, password: '' });
  };

  isArrowDisabled = () => {
    const { password } = this.state;
    return password.length === 0;
  };

  onCardReadError = error => {
    const popup = getPopupConfig('error');
    popup.message = error;
    popup.buttons = [
      {
        text: constants.cancelText,
        onClick: this.closePopup,
      },
      {
        text: constants.retry,
        onClick: () => {
          this.closePopup();
          this.scanCard();
        },
      },
    ];
    this.setState({ popup });
  }

  onCardReadSuccess = data => {
    this.closePopup();
    this.login(data);
  }

  scanCard = () => {
    const popup = getPopupConfig('spinner');
    popup.heading = constants.swipeCardMsg;
    popup.buttons = [
      {
        text: constants.cancelText,
        onClick: () => {
          this.stopMagneticCardRead(() => {
            this.setState({ popup: undefined });
          })
        },
      },
    ];
    this.setState({ popup });

    const data = {
      type: "scanMagCard",
      data: {},
    };
    UTILLib.scanMagneticCard(
      data,
      (info) => {
        this.onCardReadSuccess(info);
      },
      error => {
        this.stopMagneticCardRead();
        const popup = getPopupConfig('error', () => {
          this.setState({ popup: undefined });
        });
        popup.message = error;
        this.setState({ popup });
      },
    );
  };

  stopMagneticCardRead = (callback) => {
    const data = {
      type: "stopMagCard",
      data: {},
    };
    UTILLib.stopMagneticCard(
      data,
      () => {
        callback && callback();
      },
      error => {
        const popup = getPopupConfig('error', () => {
          this.setState({ popup: undefined });
        });
        popup.message = error;
        this.setState({ popup });
      },
    );
  }

  login = (loginId) => {
    const { dispatchLogin, reduxProps: { deviceApi, storeInfo } } = this.props;
    const { deviceId } = deviceApi?.data;
    const { supportsServerApp } = storeInfo.data.serverAppFeatures;
    if (!supportsServerApp) {
      const popup = getPopupConfig('error', () => {
        this.rawPassword = '';
        this.setState({
          popup: undefined,
          password: this.rawPassword,
        });
      });
      popup.heading = constants.errorPopupMessage;
      popup.message = constants.supportServerApp;
      this.setState({
        popup,
      });
      return;
    }
    dispatchLogin({
      deviceId,
      appVersion: version,
      employeeCode: this.rawPassword,
      employeeCard: loginId || null,
      jobId: null,
      manager: false,
    });
  }

  onLoginModeChange = () => {
    this.setState((prevState) => ({
      isCardLogin: !prevState.isCardLogin,
    }));
  }

  rawPassword = '';

  onPressHandler = (text, type) => {
    if (type && type === 'reset') {
      this.rawPassword = text;
    } else if (type && type === 'back') {
      this.rawPassword = this.rawPassword.slice(0, -1);
    } else {
      if (this.rawPassword.length === KEYPAD_MAX_LENGTH) {
        return;
      }
      this.rawPassword = this.rawPassword.concat(text);
    }
    this.setState({ password: this.rawPassword.replace(/[0-9]/g, '*') });
  };

  getProps = () => {
    const { popup, isCardLogin } = this.state;
    const { reduxProps } = this.props;
    const { storeInfo } = reduxProps || {};
    const { supportsLoginUsingCard = false, disableLoginWithKeypad = false } = storeInfo && storeInfo.data ? storeInfo.data.serverAppFeatures : {};

    return {
      popup,
      password: this.rawPassword,
      closePopup: this.closePopup,
      onKeyPress: this.onPressHandler,
      login: this.login,
      isArrowDisabled: this.isArrowDisabled,
      scanCard: this.scanCard,
      isCardLogin,
      onLoginModeChange: this.onLoginModeChange,
      supportsLoginUsingCard: supportsLoginUsingCard,
      disableLoginWithKeypad: disableLoginWithKeypad,
    };
  }

  render() {
    const viewProps = this.getProps();
    return <View {...viewProps} />;
  }
}

const mapStateToProps = reduxProps => ({
  reduxProps,
});

const mapDispatchToProps = (dispatch) => ({
  dispatchLogin: (request) => {
    dispatch(saLoginAction(request));
  },
  dispatchGetStoreJobs: body => {
    dispatch(getStoreJobsList(body));
  },
  dispatchUpdateCompState: (payload) => {
    dispatch(updateComponentState(payload));
  },
});

export default connect(
  mapStateToProps, mapDispatchToProps
)(withSocketContext(ServerAppLogin));

